<template>
  <AppIcon 
    :icon="`twemoji:flag-${COUNTRIES[code]}`"
  />
</template>

<script setup lang="ts">
import type { CountryIso } from '~/types';

const COUNTRIES: Partial<Record<CountryIso, string>> = {
  ISR: 'israel',
  SWE: 'sweden',
  USA: 'united-states',
  VNM: 'vietnam',
  IND: 'india',
  LKA: 'sri-lanka',
  CAN: 'canada',
  NZL: 'new-zealand',
  MAR: 'morocco',
  RUS: 'russia',
  KOR: 'south-korea',
  KHM: 'cambodia',
  SAU: 'saudi-arabia',
  BHR: 'bahrain',
  IDN: 'indonesia',
  GBR: 'united-kingdom',
  TGO: 'togo',
  THA: 'thailand',
  KAZ: 'kazakhstan',
  SCH: 'european-union',
  FRA: 'france'
};

defineProps<{
  code: CountryIso;
}>();
</script>